import { combineReducers } from 'redux';

import roles from './roles/roles.reducer';

/** Legacy `requests` slice (agency-metadata + PUT /users/approve) removed; Requests UI uses `team` slice. */
const usersAndPermissions = combineReducers({
    roles,
});

export default usersAndPermissions;
